import React from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

function Home(): React.ReactElement {
  const isLoggedIn = !!useAppSelector((s) => s.auth.user);
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center">
      <p className="text-gray-500 text-xs uppercase tracking-widest mb-5 font-medium">meal planning made easy</p>
      <h2 className="text-5xl font-bold text-white mb-3 leading-tight">
        What's for <span className="text-neon">supper</span>?
      </h2>
      <p className="text-gray-400 text-lg mb-10 max-w-md">
        Browse your recipes, plan your meals, and build your grocery list — all in one place.
      </p>
      <div className="flex gap-4">
        <Link
          to="/search"
          className="px-6 py-3 bg-neon hover:brightness-90 text-army-950 font-bold rounded-lg transition-all"
        >
          Find a Recipe
        </Link>
        {isLoggedIn && (
          <Link
            to="/recipes/new"
            className="px-6 py-3 bg-navy-800 hover:bg-navy-700 text-gray-200 font-medium rounded-lg border border-navy-700 transition-colors"
          >
            Add Recipe
          </Link>
        )}
      </div>
    </div>
  );
}

export default Home;
